import { Injectable } from '@angular/core';
import {Type} from "../model/Type";
import {Http, Response} from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { Headers, RequestOptions } from '@angular/http';
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";


@Injectable()
export class TypeService {

    typeUrl = environment.instantPaiementApi + "types";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}



    getListTypes(): Promise<Type[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        console.log("Récupération des types avec le jeton " + this.authenticationService.getToken());
        return this.http.get(this.typeUrl, options)
            .toPromise()
            .then(response => response.json() as Type[])
            .then(undefined, (error) => {
                console.log("erreur ==> " + error.json().error.code);
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    getType(): Promise<Type> {
        return this.http.get(this.typeUrl + "/1")
            .toPromise()
            .then((response) => response.json() as Type)
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    addType(type:Type): Promise<Type> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.typeUrl, type, options).toPromise()
            .then(this.extractData)
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    modifyType(type:Type): Promise<Type> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.put(this.typeUrl + "/" + type.id, type, options).toPromise()
            .then()
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/type.service.ts